export default __webpack_public_path__ + "static/media/img6.3b76a04c.png";